// extracted by mini-css-extract-plugin
export default {"contents":"VF-z","sectionHeading":"WF-z"};